/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlCasesCountResponse
 */
export interface ControlCasesCountResponse {
    /**
     * 
     * @type {number}
     * @memberof ControlCasesCountResponse
     */
    totalCount: number;
}

/**
 * Check if a given object implements the ControlCasesCountResponse interface.
 */
export function instanceOfControlCasesCountResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "totalCount" in value;

    return isInstance;
}

export function ControlCasesCountResponseFromJSON(json: any): ControlCasesCountResponse {
    return ControlCasesCountResponseFromJSONTyped(json, false);
}

export function ControlCasesCountResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlCasesCountResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'],
    };
}

export function ControlCasesCountResponseToJSON(value?: ControlCasesCountResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
    };
}

